/* eslint-disable react/jsx-props-no-spreading */
import { Navigate } from 'react-router-dom';
import { $auth } from 'signals/global.signals';

const PublicRoute = ({ component: Component, unauthenticatedOnly }) => {
  // If restricted route and user is signed in, redirect to appropriate dashboard
  if ($auth.value.isSignedIn && unauthenticatedOnly) {
    return <Navigate to="/" replace />;
  }

  // Render the component
  return <Component />;
};

export default PublicRoute;
